import Vue from 'vue'
// 全局注册禁止空格输入的指令
const install = (Vue) => {
  Vue.directive('no-space', {
    // 绑定时
    bind(el, binding) {
      // 针对不同组件获取实际的输入元素
      const getInput = (el) => {
        // el-input: 内部有一个 input 元素
        if (el.tagName === 'INPUT') {
          return el
        }
        // 适用于 el-input 组件
        if (el.querySelector('input')) {
          return el.querySelector('input')
        }
        // 针对 el-cascader 或其它下拉组件
        return el
      }

      // 初始处理函数
      const handleEl = (el) => {
        const input = getInput(el)

        if (input) {
          // 绑定事件处理
          input.addEventListener('input', (e) => {
            const cursorPos = e.target.selectionStart
            const hasSpace = e.target.value.includes(' ')

            if (hasSpace) {
              // 记录光标位置
              const beforeValue = e.target.value
              // 移除空格
              const afterValue = beforeValue.replace(/\s/g, '')
              e.target.value = afterValue

              // 计算删除了多少个空格
              const removedSpaces = beforeValue.length - afterValue.length

              // 修正光标位置
              e.target.setSelectionRange(cursorPos - removedSpaces, cursorPos - removedSpaces)

              // 触发 input 事件以更新 Vue 模型
              e.target.dispatchEvent(new Event('input', { bubbles: true }))
            }
          })
        }
      }

      // 首次绑定处理
      handleEl(el)

      // 对于级联选择器等组件，需要等待搜索框出现
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.addedNodes.length) {
            // 寻找新添加的搜索输入框
            const searchInputs = el.querySelectorAll('input')
            searchInputs.forEach((input) => {
              if (!input._hasNoSpaceListener) {
                input.addEventListener('input', (e) => {
                  if (e.target.value.includes(' ')) {
                    const cursorPos = e.target.selectionStart
                    const oldValue = e.target.value
                    const newValue = oldValue.replace(/\s/g, '')
                    e.target.value = newValue

                    // 修正光标位置
                    const spacesRemoved = oldValue.length - newValue.length
                    e.target.setSelectionRange(cursorPos - spacesRemoved, cursorPos - spacesRemoved)

                    // 触发事件
                    e.target.dispatchEvent(new Event('input', { bubbles: true }))
                  }
                })
                input._hasNoSpaceListener = true
              }
            })
          }
        })
      })

      // 监听DOM变化，处理动态出现的输入框
      observer.observe(el, { childList: true, subtree: true })

      // 保存引用以便清理
      el._observer = observer
    },

    // 解绑时清理
    unbind(el) {
      if (el._observer) {
        el._observer.disconnect()
      }
    }
  })
}

Vue.use(install)

export default install
